import React from "react";
// UI Framework
import DeleteIcon from "@mui/icons-material/Delete";
import { Edit } from "@mui/icons-material";
import { TableCell } from "@mui/material";
import { toast } from "react-toastify";
// Common Components
import { Loading, Modal } from "src/Components";
// Local Components
import AddModal from "./AddModal";
// Utilities
import { deleteOptionDomain } from "src/Requests/coveredCall";
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { OptionDomainReport } from "src/Interfaces/coveredCall";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: OptionDomainReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

  const cancelHandler = () => {
    setLoading(true);
    deleteOptionDomain(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {isEditModalOpen ? (
        <Modal
          title="ویرایش دامنه آپشن"
          UI={
            <AddModal
              onSuccess={onAction}
              editValues={{
                id: row.id,
                baseInstrumentId: row.baseInstrumentId,
                dividendYield: row.dividendYield,
                minYesterdayVolume: row.minYesterdayVolume,
                volatility: row.volatility,
                minYesterdayValue: row.minYesterdayValue,
              }}
              onClose={() => setIsEditModalOpen(false)}
            />
          }
          onClose={() => setIsEditModalOpen(false)}
        />
      ) : (
        <></>
      )}
      <TableCell>
        <div onClick={() => setIsEditModalOpen(true)}>
          <Edit className="!text-sky-700" />
        </div>
      </TableCell>
      <TableCell>
        <div onClick={cancelHandler}>
          {loading ? (
            <Loading size={16} className="!text-slate-700" />
          ) : (
            <DeleteIcon className="!text-red-700" />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<OptionDomainReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
